import Atom from "../../atom";
import React, { useEffect, useState } from "react";
import { LoadingBtnPropsType } from "../@types/loadingButton";
import clsx from "clsx";

export default function LoadingButton(props: LoadingBtnPropsType) {
  const { loading, className, children, ...other } = props;
  const [status, setStatus] = useState<boolean>();

  useEffect(() => {
    setStatus(loading);
    
  }, [loading]);

  return (
    <Atom.GButton
      {...other}
      className={clsx(status ? "disabled" : "", className)}
    >
      {status ? <i className="fa fa-spinner fa-spin mx-1" /> : children}
    </Atom.GButton>
  );
}
